<cp-loading-bar class="loading-bar"></cp-loading-bar>
<cp-dialog></cp-dialog>
<cp-context-menu></cp-context-menu>

<!-- Main menu -->
<cp-nav class="header"></cp-nav>
<cp-feedback-bar class="feedback-bar"></cp-feedback-bar>

<!-- Content -->
<main class="content">
  <router-outlet></router-outlet>
</main>

<!-- Footer -->
<cp-footer class="footer"></cp-footer>
